export default __webpack_public_path__ + "static/media/iconTrash.ec611aa2.svg";